import bCheckbox from '../b-checkbox/b-checkbox.vue'

// bCheckbox组件注册
bCheckbox.install = function (Vue) {
  Vue.component(bCheckbox.name, bCheckbox)
}

export default bCheckbox
